module.exports = {
	"base": {
		"welcome": "Tervetuloa Mulligansiin, %{name}!",
		"user": "Käyttäjän tiedot",
		"devices": "Laitteet",
		"refunds": "Hyvitykset",
		"resources": "Resurssit",
		"transactions": "Tilaukset ja palautukset",
		"email": "Sähköposti",
		"password": "Salasana",
		"save": "Tallenna",
		"sign-out": "Kirjaudu ulos",
		"cancel": "Peruuta",
		"close": "Sulje",
		"learn-more": "Lue lisää.",
		"required": "Tarvitaan",
		"support": "Tuki",
		"bookshelf": "Bookshelf",
		"launch": "Käynnistä",
		"download": "Lataa",
		"details": "Tiedot",
		"cannot-be-blank": "%{field} ei voi olla tyhjä.",
		"saving": "Tallennetaan...",
		"done": "Valmis",
		"failed": "Epäonnistunut",
		"copy": "Kopioi"
	},
	"signin": {
		"login-failure": "Sähköpostiosoite tai salasana ei kelpaa",
		"welcome-large": "Tervetuloa <span class='inner'>%{brand} Account Centeriin</span>",
		"welcome-small": "<span class='inner'>Account Center</span>",
		"signin-button": "Kirjaudu sisään",
		"forgot-password": "Unohditko salasanasi",
		"new-to-vst": "Uusi %{brand}ssa?",
		"create-account": "Luo tili",
		"signing-in": "Kirjaudutaan sisään...",
		"signin-failed": "Sisään kirjautuminen epäonnistui"
	},
	"transactions": {
		"price": "Hinta",
		"excluded": "(Ilman veroja)",
		"quantity": "Määrä",
		"confirmation#": "Vahvistusnumero",
		"payment": "Maksu",
		"purchased": "Ostettu",
		"purchase-details": "Oston tiedot",
		"subtotal": "Välisumma",
		"total": "Yhteensä",
		"tax": "Vero",
		"loading": "Hei tuhlari, lataamme tapahtumiasi...",
		"no-purchases": "Sinulla ei ole ostoksia.",
		"seller-vat": "Myyjän ALV-tunnus",
		"total-vat": "Maksettu %{vat} yhteensä",
		"portion": "%{subTax} Vero %{rate}%",
		"vat-disclosure": "Hinta sisältää arvonlisäveron %{vat}",
		"purchases": "Ostot",
		"refunded-items": "Tuotteet, joita palautus koskee",
		"book-title": "Kirjan nimi",
		"refund-details": "Palautuksia koskevat tiedot",
		"print-receipt": "Tulosta kuitti",
		"request-refund": "Pyydä palautusta",
		"expired": "Vanhentunut",
		"expires-in": "Vanhenee %{date}",
		"details-refund": "Tiedot ja hyvitys",
		"modal": {
			"cant-refund-title": "Hyvitystä ei saatavana",
			"cant-refund": "Kirjaasi ei voida hyvittää seuraavasta/seuraavista syystä/syistä.",
			"cant-refund-1": "Kirjaasi on katsottu liian paljon.",
			"cant-refund-2": "Ostopäivästä on kulunut yli 14 päivää.",
			"cant-refund-3": "Verkkoresurssikoodisi on paljastunut.",
			"cant-refund-4": "Kirjasi on jo hyvitetty.",
			"cant-refund-5": "Kaikki koodit on jo lunastettu ja/tai hyvitetty.",
			"cant-refund-6": "Ostopäivästä on kulunut yli 30 päivää.",
			"cant-refund-support": "Jos sinulla on vielä epäselvyyttä %{brand}n hyvityskäytännöstä, ota yhteyttä <a href='%{support_url}' target='_blank'>asiakastukeen</a>."
		},
		"license": {
			"perpetual": "Verkkopääsyoikeus ei vanhene",
			"days": "%{days} päivän pääsyoikeus"
		}
	},
	"devices": {
		"description": "%{brand} antaa mahdollisuuden pitää milloin tahansa yhtä aikaa aktivoituina <span>%{desktop}</span> tietokonetta ja <span>%{mobile}</span> mobiililaitetta/tablettia.",
		"loading": "Hei, olemme saamassa laitteesi :)",
		"no-active": "Sinulla ei ole yhtään aktiivista laitetta.",
		"deactivate": "Poista käytöstä"
	},
	"user": {
		"personal-information": "Henkilötiedot",
		"security-information": "Turvallisuustiedot",
		"notifications": "Ilmoitukset",
		"first-name": "Etunimi",
		"last-name": "Sukunimi",
		"change-password-title": "Vaihda salasana",
		"current-password": "Nykyinen salasana",
		"new-password": "Uusi salasana",
		"security-password": "Salasana",
		"confirm-new-password": "Vahvista uusi salasana",
		"security-question": "Turvakysymys",
		"security-info-change": "Muutos",
		"question": "Kysymys",
		"answer": "Vastaus",
		"notifications-text": "Lähettäkää minulle silloin tällöin päivityksiä tilini tapahtumista, tuotepäivityksistä ja erikoistarjouksista.",
		"loading": "Spot noutaa käyttäjätietojasi, hetkinen 🐶",
		"change-password-text": "Salasanassa pitää olla vähintään kahdeksan merkkiä, joista ainakin yhden pitää olla iso kirjain, yhden pieni kirjain ja yhden erikoismerkki.",
		"email-locked": "Sähköposti lukittu",
		"email-locked-description": "Et pääse muuttamaan sähköpostiosoitettasi.",
		"email-locked-more": "Ota yhteyttä administraattoriin.",
		"security-question6": "Mikä on suosikkiurheilusi?",
		"security-question7": "Mikä on suosikkijäätelösi?",
		"security-question8": "Mikä on suosikkilemmikkisi nimi?",
		"security-question9": "Kun olit lapsi, miksi halusit tulla isona?",
		"security-question10": "Mikä oli suosikkiopettajasi sukunimi?",
		"new-password-failure": "Salasana ei täytä vaatimuksia",
		"confirm-password-failure": "Salasanan on oltava sama",
		"new-password-tooltip": "Pitää sisältää vähintään 8 merkkiä, joista ainakin yhden pitää olla iso kirjan, yhden pieni kirjain ja yhden erikoismerkki.",
		"enter-valid-email": "Anna kelvollinen sähköpostiosoite.",
		"password-cannot-be-same": "Salasana ei voi olla sama kuin aikaisempi salasana",
		"incorrect-password": "Virheellinen salasana",
		"complete-account": "Näyttää siltä, että sinun pitää <a href='%{href}'>viimeistellä tilisi</a>.",
		"completing-allows": "Kun viimeistelet tilisi, voit lukea kirjoja ilman verkkoyhteyttä meidän mobiilisovelluksillamme ja jakaa muistiinpanoja ja korostuksia ystävien kanssa.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Oheistuotteet",
		"access-codes": "Pääsykoodit",
		"print-on-demand": "Tulostus tarpeen mukaan / Print on Demand",
		"check-pod": "Tarkista kustantajan kirjoistasi tarjoamat painetut vaihtoehdot.",
		"check-now": "Tarkista nyt",
		"loading": "Älä hellitä, päivitämme resurssejasi!",
		"in": ":",
		"access-code-intro": "Pääsykoodi on salasana, jolla pääset kurssisi sisältöön verkon kautta. Kun paljastat tietyn kohteen koodin, et voi enää palauttaa sitä. Katso lisäohjeita pääsykoodin käyttämisestä <a href='%{support_url}' target='_blank'>tuesta</a>.",
		"expires": "Vanhenee",
		"expiration-message": "Sisältää pääsykoodisi käyttöohjeita.",
		"copy-fail": "Ei voida kopioida. Valitse koodi ja kopioi se manuaalisesti.",
		"launch-site": "Käynnistyspaikka",
		"launch-book": "Avaa kirja",
		"reveal-code": "Paljasta koodi",
		"no-resources": "Sinulla ei ole resursseja.",
		"no-access-codes": "Sinulla ei ole pääsykoodeja.",
		"no-ancillaries": "Ei oheistuotteita tälle tittelille",
		"name": "Nimi",
		"type": "Tyyppi",
		"size": "Koko",
		"download-all": "Lataa kaikki",
		"back": "Takaisin resursseihin"
	},
	"refunds": {
		"states": {
			"refunded": "Hyvitetty",
			"unavailable": "Hyvitystä ei saatavana"
		},
		"reasons": {
			"dropped": "Luovuin kurssista",
			"wrong": "Tämä ei ollut kurssini kannalta oikea kirja",
			"print": "Päätin ostaa painetun kirjan",
			"missing": "Kirja ei sisällä kaikkea mitä kurssiani varten tarvitsen (esim. CD-levyä, pääsyä verkkopalveluihin, videoita)",
			"other": "Muu"
		},
		"bulk": {
			"policy": "Klikkaamalla alla olevaa painiketta &quot;Täysi hyvitys&quot; / &quot;Complete Refund&quot; ilmoitan hyväksyväni %{brand}in <a href='%{policy_url}' target='_blank'>hyvityskäytännön</a>.",
			"complete": "Täysi hyvitys",
			"view-details": "Katso hyvityksen (palautuksen) tiedot",
			"success": "Hyvitystäsi on pyydetty. Käsittelemme asian 48 tunnin kuluessa.",
			"failure": "Oho - jokin meni vikaan! Hyvityksesi ei ikävä kyllä mennyt läpi.",
			"retry": "Yritä uudelleen",
			"support": "Ota yhteyttä tukeen",
			"available-codes": "Käytettävissä olevat koodit",
			"codes-selected": "Valitut koodit",
			"download": "Lataa koodit",
			"partially-refunded": "Osittain hyvitetty (palautettu)",
			"pick-one": "Sinun pitää valita ainakin yksi koodi hyvitystä varten"
		},
		"refund": "Hyvitys",
		"all": "Hyvitetäänkö (palautetaanko) kaikki?",
		"missing-reason": "Sinun pitää valita syy voidaksesi jatkaa",
		"missing-elaboration": "Tarkenna",
		"policy": "Klikkaamalla alla olevaa painiketta “Complete Refund Request\" / \"Pyydä palautusta\" ilmoitan ymmärtäväni, että jos ostan tämän %{brand} eTextbook-oppikirjan uudelleen, minulla ei ole enää oikeutta pyytää hyvityksiä samasta eTextbook-oppikirjasta. Katso täydelliset palautuskäytäntöä koskevat tiedot.",
		"refunded": "Hyvitetty",
		"sorry": "Olemma pahoillamme siitä, ettet ollut tyytyväinen ostokseesi.",
		"error": "Jokin meni vikaan",
		"error-explain": "Emme pysty käsittelemään hyvitystäsi. Yritä uudelleen.",
		"why": "Kerro meille miksi?",
		"no-refunds": "Sinulla ei ole yhtään hyvitettyä tuotetta.",
		"select-codes": "Valitse hyvitettävä(t) koodi(t):",
		"number": "Kuinka monta?",
		"back": "Takaisin hyvityksiin"
	},
	"purchases": {
		"back": "Takaisin ostoksiin"
	},
	"global-bar": {
		"account": "Tilin asetukset"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/fi.json
 ** module id = 1005
 ** module chunks = 0
 **/